<button wfsBadge *ngIf="activeTemplate"
	[iconName]="activeTemplate.symbol"
	[borderColor]="activeTemplate.borderColor"
	[tooltip]="activeTemplate.label"
	[backgroundColor]="activeTemplate.color"
	[disabled]="activeTemplate.disabled"
></button>
